const API_BASE = process.env.REACT_APP_API_URL || "http://127.0.0.1:4998";

async function getAuthHeaders(includeJson = false) {
  const { supabase } = await import("../../supabase");
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) {
    throw new Error("No active session");
  }
  const headers = { Authorization: `Bearer ${session.access_token}` };
  if (includeJson) {
    headers["Content-Type"] = "application/json";
  }
  return headers;
}

export async function fetchBacktestConfigs() {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE}/api/backtest-configs`, { headers });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to fetch backtest configs");
  }
  return data.backtest_configs || [];
}

export async function createBacktestConfig(payload) {
  const headers = await getAuthHeaders(true);
  const response = await fetch(`${API_BASE}/api/backtest-configs`, {
    method: "POST",
    headers,
    body: JSON.stringify(payload)
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to create backtest config");
  }
  return data.backtest_config;
}

export async function updateBacktestConfig(configId, payload) {
  const headers = await getAuthHeaders(true);
  const response = await fetch(`${API_BASE}/api/backtest-configs/${configId}`, {
    method: "PUT",
    headers,
    body: JSON.stringify(payload)
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to update backtest config");
  }
  return data.backtest_config;
}

export async function deleteBacktestConfig(configId) {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE}/api/backtest-configs/${configId}`, {
    method: "DELETE",
    headers
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to delete backtest config");
  }
  return data;
}
